import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const CrossInvertedCircled = forwardRef(({ size = 'medium', fill = 'currentColor', innerFill = 'transparent', ...props }, ref) => {
    const innerFillValue = innerFill === 'transparent' ? 'transparent' : 'var(--cb-icon-inner-color-contrast)';
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10", fill: innerFillValue }), _jsx("path", { fillRule: "evenodd", d: "M14.125 5.791a1.215 1.215 0 0 1 0 1.72l-2.406 2.405 2.406 2.406a1.215 1.215 0 0 1-1.719 1.719L10 11.635 7.594 14.04a1.215 1.215 0 1 1-1.719-1.719l2.406-2.406L5.875 7.51a1.215 1.215 0 1 1 1.719-1.719L10 8.198l2.406-2.407a1.215 1.215 0 0 1 1.719 0" })] }));
});
CrossInvertedCircled.displayName = 'CrossInvertedCircled';
CrossInvertedCircled.__iconComponentType = 'contrast';
export default CrossInvertedCircled;
//# sourceMappingURL=CrossInvertedCircled.js.map